import React, { Component } from 'react'

export class Portfolio extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <div className="portfolio__profile-pic">
          <img src="/images/profile-pic.png" alt="Soham Karandikar" className="profile-pic"/>
        </div>
        <div className="portfolio center">
        
          <div className="portfolio__introduction">
            <p>
            <span role="img" aria-label="hello">👋</span> Hi there! I'm <strong>Soham Ravindra Karandikar</strong>. An asipiring fullstack developer from <strong>Pune</strong>. I am proficient in HTML, CSS and Javascript. I am currently learning <span className="react-text">React</span> and <span className="nodejs-text">Node.js</span> along with Mongo DB. I have also worked with Electron and Puppeteer.js. I have recently completed 10th Boards and am looking for an <strong>internship</strong> to gain hands-on development experience. You can contact on my <a target="_blank" rel="noopener noreferrer" href="https://instagram.com/s.k.a.d.e.w.d.l.e"><strong className="instagram-link">Instagram</strong></a> and <a href="https://www.linkedin.com/in/soham-karandikar-b994301a8/" rel="noopener noreferrer" target="_blank"><strong className="linkedin-link">Linkedin</strong></a>.
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default Portfolio
